module.exports = __webpack_public_path__ + "static/media/10.1b8f4ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/eyebrowes/10.png
// module id = 1195
// module chunks = 0